import { IconProps } from "../../utils/global-types/global-types";

const DeviceTypeIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    className={className ? className : "w-[14px] h-[14px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M11.83 6.027H9.75a.42.42 0 0 0-.419.42v4.411a.42.42 0 0 0 .419.42h2.079a.42.42 0 0 0 .419-.42V6.446a.42.42 0 0 0-.42-.419m-.748 4.667h-.583a.194.194 0 1 1 0-.389h.583a.194.194 0 1 1 0 .389"
    ></path>
    <path
      fill="currentColor"
      d="M11.278 5.638V3.456a.74.74 0 0 0-.735-.734H2.485a.736.736 0 0 0-.735.734V8.21a.74.74 0 0 0 .735.735h6.46V6.446c0-.445.362-.808.807-.808zM6.806 8.254h-.584a.195.195 0 0 1 0-.389h.584a.195.195 0 0 1 0 .39M8.555 10.889h-.778V9.333H5.25v1.556h-.778a.194.194 0 0 0 0 .389h4.083a.194.194 0 0 0 0-.39"
    ></path>
  </svg>
);

export default DeviceTypeIcon;
